import { submitNewForm, submitNewFormExt } from '../app/presurvey/formSlice';
import { useAuth } from '@praxis/component-auth';
import { useDispatch } from 'react-redux';
import { useInstallerAuthContext } from './useInstallerAuthContext';
import { logEvent, LogLevel } from '@praxis/component-logging';

export function useSurveyDispatch(formData, imgFiles, setIsPhotoMinHit) {
  const auth = useAuth();
  const { session } = auth;
  const { user } = useInstallerAuthContext();
  const dispatch = useDispatch();

  const dispatchEndpoint = async () => {
    if (imgFiles?.length < 2 || imgFiles?.length > 12) {
      //Checking photo requirement before submission
      setIsPhotoMinHit(true);
      throw new Error(
        'Invalid number of photos. Please review your submission.',
      );
    }

    try {
      if (session) {
        await dispatch(submitNewForm(formData)).unwrap();
      } else if (user) {
        const { token } = user;
        await dispatch(submitNewFormExt({ formData, token })).unwrap();
      }
    } catch (err) {
      logEvent({ message: err }, { level: LogLevel.Error });
      throw new Error('Unable to submit form at this time');
    }
  };
  return { dispatchEndpoint };
}
